import { Location } from '../../../types/models/Location.model'
import { isNumber } from '../../../utils/checks'
type LocationRadiusType = Pick<Location, 'miRadius'>

const getCustomRadiusFromLocation = (location: LocationRadiusType): number =>
  isNumber(location?.miRadius) ? location.miRadius : 0

export default getCustomRadiusFromLocation
